module.exports = __webpack_public_path__ + "common/gh-magnifier-fb2223b7e2dc867f4a33de14d44b6eab.svg";